import {
  BrowserRouter,
  Routes,
  Route,
  Navigate
} from "react-router-dom";

// ==========================
// 📄 PAGES
// ==========================

import CEOApproval from "./pages/CEOApproval";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Claims from "./pages/Claims";

import SalesClaim from "./pages/SalesClaim";
import MyClaims from "./pages/MyClaims";
import QRGenerator from "./pages/QRGenerator";
import ManagerClaims from "./pages/ManagerClaims";
import AssignSalesman from "./pages/AssignSalesman";
import AssignManager from "./pages/AssignManager";
import ManagerReports from "./pages/ManagerReports";
import CEOReports from "./pages/CEOReports";
import FinancePayoutScreen from "./pages/FinancePayoutScreen";
import FinancePayoutHistory from "./pages/FinancePayoutHistory";
import IncentiveMatrix from "./pages/IncentiveMatrix";



// ==========================
// 🧱 LAYOUT
// ==========================

import AppShell
from "./layouts/AppShell";
// ==========================
// 🔐 AUTH HELPERS
// ==========================

const getUser = () => {

  const token =
    localStorage.getItem("token");

  const user =
    localStorage.getItem("user");

  return token && user
    ? JSON.parse(user)
    : null;
};

// ==========================
// 🔐 PRIVATE ROUTE
// ==========================

function PrivateRoute({
  children
}) {

  return getUser()

    ? children

    : <Navigate
        to="/login"
        replace
      />;
}

// ==========================
// 🔐 ROLE ROUTE
// ==========================

function RoleRoute({
  roles,
  children
}) {

  const user =
    getUser();

  if (!user) {

    return (
      <Navigate
        to="/login"
        replace
      />
    );
  }

  const role =
    String(user.role || "")
      .toLowerCase()
      .trim();

  const allowed =
    roles.map((r) =>
      r.toLowerCase()
    );

  if (
    !allowed.includes(role)
  ) {

    return (
      <Navigate
        to="/"
        replace
      />
    );
  }

  return children;
}

// ==========================
// 🚀 APP
// ==========================

function App() {

  const user =
    getUser();

  return (

    <BrowserRouter>

     

      {/* =====================================
          ROUTES
      ===================================== */}

      <Routes>

        {/* ================= LOGIN ================= */}

        <Route
          path="/login"
          element={<Login />}
        />

        {/* ================= PROTECTED APP ================= */}

        <Route
          path="/"
          element={

            <PrivateRoute>

             <AppShell />

            </PrivateRoute>
          }
        >

          {/* ================= DASHBOARD ================= */}

          <Route
            index
            element={<Dashboard />}
          />

          {/* ================= CEO ================= */}

          <Route
            path="final-approval"
            element={

              <RoleRoute
                roles={["ceo"]}
              >

                <CEOApproval />

              </RoleRoute>
            }
          />

          <Route
            path="ceo-reports"
            element={

              <RoleRoute
                roles={["ceo"]}
              >

                <CEOReports />

              </RoleRoute>
            }
          />

          {/* ================= ADMIN ================= */}

          <Route
            path="assign-salesman"
            element={

              <RoleRoute
                roles={["admin"]}
              >

                <AssignSalesman />

              </RoleRoute>
            }
          />

          <Route
            path="assign-manager"
            element={

              <RoleRoute
                roles={["admin"]}
              >

                <AssignManager />

              </RoleRoute>
            }
          />

          <Route
            path="qr"
            element={

              <RoleRoute
                roles={["admin"]}
              >

                <QRGenerator />

              </RoleRoute>
            }
          />

          <Route
  path="incentive-matrix"
  element={
    <RoleRoute
      roles={[
        "admin",
        "manager",
        "ceo",
        "finance"
      ]}
    >
      <IncentiveMatrix />
    </RoleRoute>
  }
/>
{/* ================= MANAGER ================= */}

<Route
  path="manager"
  element={

    <RoleRoute
      roles={["manager"]}
    >

      <Dashboard />

    </RoleRoute>
  }
/>

<Route
  path="manager-approvals"
  element={

    <RoleRoute
      roles={["manager"]}
    >

      <ManagerClaims />

    </RoleRoute>
  }
/>

<Route
  path="manager-reports"
  element={

    <RoleRoute
      roles={["manager"]}
    >

      <ManagerReports />

    </RoleRoute>
  }
/>

{/* ================= CLAIMS ================= */}

<Route
  path="claims"
  element={

    <RoleRoute
      roles={[
        "admin",
        "manager",
        "ceo"
      ]}
    >

      <Claims />

    </RoleRoute>
  }
/>

          {/* ================= SALESMAN ================= */}

          <Route
            path="sales"
            element={

              <RoleRoute
                roles={[
                  "salesman"
                ]}
              >

                <SalesClaim />

              </RoleRoute>
            }
          />

          <Route
            path="my-claims"
            element={

              <RoleRoute
                roles={[
                  "salesman"
                ]}
              >

                <MyClaims />

              </RoleRoute>
            }
          />

        {/* ================= FINANCE ================= */}

        <Route
          path="payouts"
          element={

            <RoleRoute
              roles={[
                "finance"
              ]}
            >

              <FinancePayoutScreen />

            </RoleRoute>
          }
        />

        <Route
          path="finance-reports"
          element={

            <RoleRoute
              roles={[
                "finance"
              ]}
            >

              <FinancePayoutHistory />

            </RoleRoute>
          }
        />

      </Route>

      {/* ================= FALLBACK ================= */}

      <Route
        path="*"
        element={
          <Navigate
            to="/"
            replace
          />
        }
      />

    </Routes>

  </BrowserRouter>
);
}

export default App;